import { TripTypeEnum } from '../../types/enums/trip/trip-type.enum'
import { TripStepTypeEnum } from '../../types/enums/trip-bookings/trip-step-type.enum'
import { TripFolderFilters } from '../../types/models/trip-folder/trip-folder-filtes'

export const transformTripFolderFilterToUrl = (filters?: TripFolderFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.date !== undefined && filters.date !== null) searchParams.set('date', filters.date)

  if (filters.locked !== undefined) searchParams.set('locked', filters.locked.toString())
  if (filters.year !== undefined) searchParams.set('year', filters.year.toString())

  if (filters.tripIds && filters.tripIds.length > 0)
    searchParams.set('trips', filters.tripIds.join(','))

  if (filters.tripTypes && filters.tripTypes.length > 0)
    searchParams.set('tripTypes', filters.tripTypes.join(','))

  if (filters.directionalities && filters.directionalities.length > 0)
    searchParams.set('directionalities', filters.directionalities.join(','))

  if (filters.departurePlaceIds && filters.departurePlaceIds.length > 0)
    searchParams.set('departurePlaceIds', filters.departurePlaceIds.join(','))

  if (filters.arrivalPlaceIds && filters.arrivalPlaceIds.length > 0)
    searchParams.set('arrivalPlaceIds', filters.arrivalPlaceIds.join(','))

  return searchParams.toString()
}

export const transformUrlToTripFolderFilter = (
  searchParams: URLSearchParams
): TripFolderFilters => {
  const filters: TripFolderFilters = {}

  const date = searchParams.get('date')
  if (date) filters.date = date

  const locked = searchParams.get('locked')
  if (locked != undefined) filters.locked = locked === 'true' ? true : false

  const year = searchParams.get('year')
  if (year) filters.year = isNaN(parseInt(year, 10)) ? undefined : parseInt(year, 10)

  const tripTypes = searchParams.get('tripTypes')
  if (tripTypes) filters.tripTypes = tripTypes.split(',') as TripTypeEnum[]

  const directionalities = searchParams.get('directionalities')
  if (directionalities)
    filters.directionalities = directionalities.split(',') as TripStepTypeEnum[]

  const tripIds = searchParams.get('trips')
  if (tripIds) filters.tripIds = tripIds.split(',').map((id) => parseInt(id, 10))

  const departurePlaceIds = searchParams.get('departurePlaceIds')
  if (departurePlaceIds) filters.departurePlaceIds = departurePlaceIds.split(',').map(Number)

  const arrivalPlaceIds = searchParams.get('arrivalPlaceIds')
  if (arrivalPlaceIds) filters.arrivalPlaceIds = arrivalPlaceIds.split(',').map(Number)

  return filters
}
